/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiAlbumsQueryResponse, GetApiAlbumsQueryParams, GetApiAlbums400, GetApiAlbums401, GetApiAlbums403, GetApiAlbums500 } from "../../types/GetApiAlbums.ts";
import { getApiAlbumsQueryResponseSchema } from "../../zod/AlbumSchemas/getApiAlbumsSchema.ts";

function getGetApiAlbumsUrl() {
  const res = { method: 'GET', url: `/api/albums` as const }  
  return res
}

/**
 * @summary Метод получения списка альбомов с пагинацией и фильтрацией.
 * {@link /api/albums}
 */
export async function getApiAlbums({ params }: { params?: GetApiAlbumsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiAlbumsQueryResponse, ResponseErrorConfig<GetApiAlbums400 | GetApiAlbums401 | GetApiAlbums403 | GetApiAlbums500>, unknown>({ method : "GET", url : getGetApiAlbumsUrl().url.toString(), params, ... requestConfig })  
  return getApiAlbumsQueryResponseSchema.parse(res.data)
}